import { readRuntimeConfig } from "./runtimeConfig";

const trim = (value: string | undefined) => value?.trim() ?? "";

const runtime = readRuntimeConfig();

const configuredApi = trim(
  runtime.apiBaseUrl ?? import.meta.env.VITE_API_BASE_URL,
);
const configuredIdentityApi = trim(
  runtime.identityApiBaseUrl ?? import.meta.env.VITE_IDENTITY_API_BASE_URL,
);
const configuredIdentityLogin = trim(
  runtime.identityLoginUrl ?? import.meta.env.VITE_IDENTITY_LOGIN_URL,
);
const configuredPublicForms = trim(
  runtime.publicFormsBaseUrl ?? import.meta.env.VITE_PUBLIC_FORMS_BASE_URL,
);

const configuredMediaCdn = trim(
  (runtime as { mediaCdnUrl?: string }).mediaCdnUrl ??
    import.meta.env.VITE_MEDIA_CDN_URL,
);

const DEFAULT_IDENTITY_API_BASE_URL = "https://chm12.ru";
const DEFAULT_IDENTITY_LOGIN_URL = "https://id.chm12.ru/login";
const DEFAULT_PUBLIC_FORMS_BASE_URL = "https://forms.chm12.ru";

function withoutTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function isSameOriginValue(value: string): boolean {
  return value === "same-origin" || value === "SAME_ORIGIN";
}

/** Пустой baseUrl только в dev — Vite проксирует /api. */
function resolveApiBaseUrl(): string {
  if (import.meta.env.DEV) return "";
  if (!configuredApi || isSameOriginValue(configuredApi)) {
    return "";
  }
  return withoutTrailingSlash(configuredApi);
}

/** В dev запросы к chm12.ru идут через Vite, чтобы localhost не упирался в CORS. */
function resolveIdentityApiBaseUrl(): string {
  if (import.meta.env.DEV) return "/chm-api";
  return withoutTrailingSlash(
    configuredIdentityApi || DEFAULT_IDENTITY_API_BASE_URL,
  );
}

export const env = {
  apiBaseUrl: resolveApiBaseUrl(),
  identityApiBaseUrl: resolveIdentityApiBaseUrl(),
  identityLoginUrl: configuredIdentityLogin || DEFAULT_IDENTITY_LOGIN_URL,
  apiToken: trim(runtime.apiToken ?? import.meta.env.VITE_API_TOKEN),
  publicFormsBaseUrl: withoutTrailingSlash(
    configuredPublicForms || DEFAULT_PUBLIC_FORMS_BASE_URL,
  ),
  mediaCdnUrl:
    configuredMediaCdn || "https://storage.yandexcloud.net/chmrufiles",
} as const;
